/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module SiteSearch
define(
    'SiteSearch.Button.View'
,	[
		'SC.Configuration'
	,	'site_search_button.tpl'
    ,	'Backbone'
    ,	'Utils'
    ,	'Backbone.CompositeView'
	]
,	function(
		Configuration
	,	site_search_button
	,	Backbone
    ,	Utils
    ,	BackboneCompositeView
	)
{
	'use strict';

	// @class Site.Search.Button.View @extends Backbone.View
	return Backbone.View.extend({

    	events: {
            'click [data-action="show-itemsearcher"]': 'toggleSiteSearch'
        }

		// @property {Function} template
	,	template: site_search_button

		// @method initialize
		// @param {Site.Search.Button.View.Initialize.Options} options
		// @return {Void}
    ,	initialize: function ()
        {
            this.application = this.options.application;

            BackboneCompositeView.add(this);
        }
    
    
        // @method toggleSiteSearch
	,	toggleSiteSearch: function (ev)
        {
            ev && ev.preventDefault();

            // This add a class 'active' to change button color
            this.$('[data-action="show-itemsearcher"]').toggleClass('active');
            var self = this;

            this.application.getLayout().trigger('toggleItemSearcher');
        }
});
});

